import { PageHeader, Select, Popconfirm, message, Tooltip } from "antd";
import { CheckCircleOutlined, EditOutlined, StopOutlined, ImportOutlined, ClusterOutlined, PlusOutlined } from "@ant-design/icons";

import React, { Component } from "react";
import { connect } from "react-redux";
import { SelectItem, TableItemDinamico, ButtonItem, SegmentedItem } from "../../../Components/Items";
import round4Decimals from "../../../Components/round4Decimals";
import axios from "axios";
import AgregarUbicacion from "./AgregarUbicacion/AgregarUbicacion";
import EditarUbicacion from "./EditarUbicacion/EditarUbicacion";

const { Option } = Select;


class Ubicaciones extends Component {
    tableRef = null;
    state = {
        loading: false,
        proyecto: undefined,
        proyectoId: undefined,
        todosProyectos: [],
        objetoProyectos: [],
        todasUbicaciones: [],
        totalRecords: 0,
        textoFiltro: "",
        //Variables para el modal de agregar ubicación
        modalAgregarUbicacion: false,
        //Variables para el modal de editar ubicación
        modalEditarUbicacion: false,
        ubicacionSeleccionada: undefined,
        valor: 1,
        racksProyecto: [],
        rackId: undefined,
    }
    componentDidMount() {
        this.consultarProyectos();
    }

    //Métodos para abrir y cerrar el modal de agregar ubicación
    //El almacén se elige dentro del modal, no hace falta tener uno preseleccionado en la pantalla.
    abrirModalAgregarUbicacion = () => {
        this.setState({ modalAgregarUbicacion: true });
    };
    cerrarModalAgregarUbicacion = () => {
        this.setState({ modalAgregarUbicacion: false });
        this.refrescarTabla();
    };

    //Métodos para abrir y cerrar el modal de editar ubicación
    abrirModalEditarUbicacion = (valor) => {
        this.setState({
            modalEditarUbicacion: true,
            ubicacionSeleccionada: valor,
        });
    };
    cerrarModalEditarUbicacion = () => {
        this.setState({ modalEditarUbicacion: false });
        this.refrescarTabla();
    };

    abrirImportarUbicaciones = () => {
        if (!this.state.proyectoId) {
            return;
        }
        this.props.history.push("/panel/importarUbicaciones", {
            proyectoId: this.state.proyectoId,
            proyecto: this.state.proyecto,
        });
    };

    abrirMapa = () => {
        if (!this.state.proyectoId) {
            return;
        }
        this.props.history.push("/panel/mapa", {
            proyectoId: this.state.proyectoId,
            proyecto: this.state.proyecto,
        });
    };

    //Vuelve a pedir la página actual con los filtros (proyecto/estado) vigentes
    refrescarTabla = () => {
        this.tableRef?.updateExternalFilters({
            proyectoId: this.state.proyectoId,
            valor: this.state.valor,
        });
    };

    //Función para consultar la lista de proyectos para el selector
    async consultarProyectos() {
        await axios
            .post("proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) { }
                else {
                    this.setState({ todosProyectos: res.data });
                    this.setState({
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id} >
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
    }

    //Callback que usa TableItemDinamico para pedir cada página al servidor
    consultarUbicacionesTabla = (params) => {
        this.setState({ loading: true });
        axios
            .post(
                "ubicacionProyecto/selectUbicacionesTabla",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasUbicaciones: res.data.data || [],
                        totalRecords: res.data.totalRecords || 0,
                        loading: false,
                    });
                } else {
                    this.setState({ todasUbicaciones: [], totalRecords: 0, loading: false });
                }
            })
            .catch((error) => {
                console.error("Error al consultar ubicaciones:", error);
                this.setState({ loading: false });
            });
    };

    onChangeProyecto(value) {
        if (value === 0) {
            this.setState({ proyecto: undefined, proyectoId: undefined, racksProyecto: [], rackId: undefined }, () => {
                this.tableRef?.updateExternalFilters({ proyectoId: undefined, rackId: undefined, valor: this.state.valor });
            });
        }
        else {
            const proyecto = this.state.todosProyectos.find((proyecto) => proyecto._id === value);
            this.setState({ proyecto: proyecto?.nombre, proyectoId: value, rackId: undefined }, () => {
                this.tableRef?.updateExternalFilters({ proyectoId: value, rackId: undefined, valor: this.state.valor });
                this.consultarRacksProyecto(value);
            });
        }
    }

    //Carga los racks del almacén para poblar el dropdown de filtro de la tabla.
    consultarRacksProyecto(proyectoId) {
        axios
            .post("rack/selectRacksDeProyecto", { empresaId: this.props.empresaId, proyectoId }, { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) this.setState({ racksProyecto: res.data.racks || [] });
                else this.setState({ racksProyecto: [] });
            })
            .catch(() => this.setState({ racksProyecto: [] }));
    }

    //Evento para el selector de rack
    onChangeRack(value) {
        const rackId = value === 0 ? undefined : value;
        this.setState({ rackId }, () => {
            this.tableRef?.updateExternalFilters({ proyectoId: this.state.proyectoId, rackId, valor: this.state.valor });
        });
    }

    //Funciones para deshabilitar y habilitar ubicaciones

    habilitarUbicacion(value) {
        axios
            .post(
                "ubicacionProyecto/habilitarUbicacionProyecto",
                { _id: value },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Ubicación habilitada");
                } else {
                    message.error("Sucedió un error y no se pudo habilitar");
                }
                this.refrescarTabla();
            });
    }
    deshabilitarUbicacion(value) {
        axios
            .post(
                "ubicacionProyecto/deshabilitarUbicacionProyecto",
                { _id: value },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Ubicación deshabilitada");
                } else {
                    message.error("Sucedió un error y no se pudo deshabilitar");
                }
                this.refrescarTabla();
            });
    }

    render() {
        const columns = [
            {
                title: "Clave",
                dataIndex: "clave",
                responsive: ["md"],
                key: "clave",
                buscar: "clave",
                width: "7%"
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                sorter: true,
                defaultSortOrder: "ascend",
                buscar: "nombre",
                width: "11%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                render: (value) => value || "-",
                width: "18%",
            },
            {
                title: "Secuencia",
                dataIndex: "secuencia",
                key: "secuencia",
                sorter: true,
                width: "6%",
                render: (value) => Number(value) || "-",
            },
            {
                title: "Secuencia de recorrido",
                dataIndex: "secuenciaRecorrido",
                key: "secuenciaRecorrido",
                sorter: true,
                width: "8%",
                render: (value) => Number(value) || "-",
            },
            {
                title: "Cantidad Máxima",
                dataIndex: "cantidadMaxima",
                key: "cantidadMaxima",
                sorter: true,
                width: "8%",
                render: (value) => Number(value) || "-",
            },
            {
                title: "Dimensiones (mts)",
                key: "dimensiones",
                render: (record) => {
                    const { ancho, largo, alto } = record;
                    if (ancho === undefined && largo === undefined && alto === undefined) return "-";
                    return `${ancho ?? "-"} x ${largo ?? "-"} x ${alto ?? "-"}`;
                },
                width: "10%",
            },
            {
                title: "Volumen",
                dataIndex: "volumen",
                key: "volumen",
                sorter: true,
                width: "6%",
                render: (value) => (value === undefined || value === null ? "-" : round4Decimals(value)),
            },
            {
                title: "Número de rack",
                dataIndex: "numeroRack",
                key: "numeroRack",
                render: (value) => Number(value) || "-",
                width: "7%",
            },
            {
                title: "Nivel de rack",
                dataIndex: "nivelRack",
                key: "nivelRack",
                render: (value) => Number(value) || "-",
                width: "7%",
            },
            {
                title: "Rack",
                dataIndex: "rack",
                key: "rack",
                width: "8%",
                render: (rack) =>
                    rack ? (
                        <Tooltip title={rack.nombre || rack.codigo}>{rack.codigo}</Tooltip>
                    ) : (
                        "-"
                    ),
            },
            {
                title: "Observaciones",
                dataIndex: "observaciones",
                key: "observaciones",
                width: "13%",
                render: (value) => value || "-",
            },
            {
                title: "Acciones",
                key: "acciones",
                align: "center",
                width: "6%",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value) => {
                    let buttons = [];

                    const puedeEditar = this.props.permisoEditarUbicacion;
                    buttons.push(
                        <Tooltip title={puedeEditar ? "Editar Ubicación" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => puedeEditar && this.abrirModalEditarUbicacion(value)}
                                disabled={!puedeEditar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    if (this.props.permisoDeshabilitarUbicacion) {
                        if (value.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    title="¿Estás seguro de deshabilitar esta ubicación?"
                                    onConfirm={() => this.deshabilitarUbicacion(value._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip title="Deshabilitar Ubicación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    title="Seguro que quieres habilitar esta ubicación"
                                    onConfirm={() => this.habilitarUbicacion(value._id)}
                                    okText="Si"
                                    cancelText="No"
                                >
                                    <Tooltip title="Habilitar Ubicación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            }
        ];

        return (
            <>
                <PageHeader
                    title={this.state.proyecto ? "Ubicaciones del Almacén: " + this.state.proyecto : "Ubicaciones del Almacén: Todos"}
                    style={{
                        border: "1px solid rgb(235,237,240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: "Activo", value: 1 }, { label: "Deshabilitado", value: 2 }, { label: "Todos", value: 3 }]}
                                        onChange={(value) => {
                                            this.setState({ valor: value }, () => {
                                                this.tableRef?.updateExternalFilters({ proyectoId: this.state.proyectoId, rackId: this.state.rackId, valor: value });
                                            });
                                        }}
                                    />
                                    <div className="header-divider"></div>
                                </>}
                            {(this.state.proyecto && this.props.permisoAgregarUbicacion) &&
                                <ButtonItem
                                    key="importarUbicaciones"
                                    icon={<ImportOutlined />}
                                    onClick={this.abrirImportarUbicaciones}
                                    className="botonAgregar"
                                    verde
                                >
                                    Importar Ubicaciones
                                </ButtonItem>}
                            {this.state.proyecto &&
                                <ButtonItem
                                    key="mapaUbicaciones"
                                    icon={<ClusterOutlined />}
                                    onClick={this.abrirMapa}
                                    className="botonAgregar"
                                    petroleo
                                >
                                    Ver mapa
                                </ButtonItem>}
                            {this.props.permisoAgregarUbicacion &&
                                <ButtonItem
                                    type="primary"
                                    icon = {<PlusOutlined />}
                                    key="agregarUbicacion"
                                    onClick={this.abrirModalAgregarUbicacion}
                                    className="botonAgregar"
                                    olivo
                                >
                                    Agregar ubicación al almacén
                                </ButtonItem>}

                            <SelectItem
                                placeholder="Almacén"
                                width={200}
                                onChange={this.onChangeProyecto.bind(this)}
                                defaultValue={0}
                            >
                                <Option value={0}>Todos</Option>
                                {this.state.objetoProyectos}
                            </SelectItem>
                            {this.state.proyectoId && (
                                <SelectItem
                                    placeholder="Rack"
                                    width={170}
                                    value={this.state.rackId || 0}
                                    onChange={this.onChangeRack.bind(this)}
                                >
                                    <Option value={0}>Todos los racks</Option>
                                    {this.state.racksProyecto.map((r) => (
                                        <Option key={r._id} value={r._id}>
                                            {r.codigo}{r.nombre ? ` - ${r.nombre}` : ""}
                                        </Option>
                                    ))}
                                </SelectItem>
                            )}
                        </div>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    onFetchData={this.consultarUbicacionesTabla}
                    totalRecords={this.state.totalRecords}
                    dataSource={this.state.todasUbicaciones}
                    loading={this.state.loading}
                    columns={columns}
                    size="small"
                    pagination={false}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    valorTextoDefault={""}
                    anadirValorFiltro={this.state.valor}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />

                <AgregarUbicacion
                    visible={this.state.modalAgregarUbicacion}
                    onClose={this.cerrarModalAgregarUbicacion}
                    proyectoId={this.state.proyectoId}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                />

                <EditarUbicacion
                    visible={this.state.modalEditarUbicacion}
                    onClose={this.cerrarModalEditarUbicacion}
                    ubicacion={this.state.ubicacionSeleccionada}
                    proyectoId={this.state.proyectoId}
                    empresaId={this.props.empresaId}
                    usuarioId={this.props.usuarioId}
                    headersToken={this.props.headersToken}
                />
            </>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user?.id,
        permisoAgregarUbicacion: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a5408afe00cff7ab4c38913")?.activado,
        permisoEditarUbicacion: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a5408bde00cff7ab4c38914")?.activado,
        permisoDeshabilitarUbicacion: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a5408e0e00cff7ab4c38916")?.activado,
    };
};
export default connect(mapStateToProps)(Ubicaciones);
